export default function translateListOrObject(
  object: unknown,
  translateFunction: (object: unknown) => unknown
): unknown {
  if (Array.isArray(object)) {
    return object.map((obj) => translateListOrObject(obj, translateFunction));
  } else if (object != null) {
    return translateFunction(object);
  } else {
    return null;
  }
}
